var _rect, _rect2, _rect3, _rect4, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.5971,
    height: 1.334,
    transform: "matrix(0.999999 0.0012952 -0.000511322 1 1.44434 9.60001)",
    fill: "#9EA3AD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 21.5971,
    height: 1.334,
    transform: "matrix(0.999999 0.0012952 -0.000511322 1 1.44238 14.0022)",
    fill: "#9EA3AD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.71011,
    height: 3.15714,
    transform: "matrix(0.999999 0.0012952 -0.000511322 1 2.4209 10.8908)",
    fill: "#9EA3AD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.71011,
    height: 3.15714,
    transform: "matrix(0.999999 0.0012952 -0.000511322 1 10.8867 10.9017)",
    fill: "#9EA3AD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.71011,
    height: 3.15714,
    transform: "matrix(0.999999 0.0012952 -0.000511322 1 19.3525 10.9128)",
    fill: "#9EA3AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPallet);
export default __webpack_public_path__ + "static/media/Pallet.0509ed1ea0b27b931111c4456e865b23.svg";
export { ForwardRef as ReactComponent };